export { default as useImageSupport } from './useImageSupport';
